import React, { useState } from "react";
import styled from "@emotion/styled";

const StyledButton = styled.button`
  padding: 0;
  background: none;
  border: none;
  outline: 0;
  cursor: pointer;
  color: #0074d9;
  &:active {
    border: none;
  }
  &:hover {
    color: #001f3f;
  }
`;

interface IReadMoreProps {
  text: string;
  maxLength: number;
}

const getTextToDisplay = ({
  text,
  maxLength,
  showAll,
}: {
  text: string;
  maxLength: number;
  showAll: boolean;
}) => {
  if (showAll) {
    return `${text} `;
  }
  if (text.length <= maxLength) {
    return text;
  } else {
    return `${text.substr(0, maxLength)}... `;
  }
};

export const ReadMore = ({ text, maxLength }: IReadMoreProps) => {
  const [showAll, setShowAll] = useState(false);
  const trigger = (
    <StyledButton onClick={() => setShowAll(!showAll)}>
      {showAll ? "Read less" : "Read more"}
    </StyledButton>
  );
  const displayText = getTextToDisplay({ text, maxLength, showAll });
  return (
    <div>
      {displayText}
      {text.length > maxLength && trigger}
    </div>
  );
};
